import RegisterForm from "./register-form.vue";

const promise = new Promise(resolve => {
  vueApp.component('register-form', RegisterForm);
  resolve();
});

window.pendingComponentLoads.push(promise);